export default "__VITE_ASSET__DFM0GArF__"